<template>
  <el-dialog
    :title="title"
    :visible.sync="isInfo"
    :close-on-click-modal="false"
    @close="close"
    top="30vh"
  >
    <el-form ref="fForm" :model="ruleForm" size="small" label-width="100px">
      <el-row>
        <el-col>
          <el-form-item label="班次名称：">
            {{ ruleForm.className }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="作业名称：">
            {{ ruleForm.workName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="作业时间：">
            {{ ruleForm.createDate }}至{{ ruleForm.remedyDeadline }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="批改方式：">
            {{ ruleForm.workReviewTypeName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="作业分类：">
            {{ ruleForm.workTypeName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label=" 作业需求：">
            {{ ruleForm.workDesc }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <butn btntype="primary" title="确定" @click.native="close"></butn>
  </el-dialog>
</template>

<script>
import Bus from "./Bus.js";
import butn from "@/components/button/index";
export default {
  name: "detail",
  components: { butn },
  data() {
    return {
      isInfo: false,
      title: "作业详情",
      categoryData: [],
      ruleForm: {
        className: "",
        workName: "",
        createDate: "",
        workTypeName: "",
        remedyDeadline: "",
        workDesc: "",
        workReviewTypeName: "",
      },
    };
  },
  methods: {
    close() {
      // 点击取消 数据重置
      this.isInfo = false;
    },
  },
  created() {
    Bus.$on("infoBook", (data) => {
      this.isInfo = true;
      this.ruleForm.className = data.className;
      this.ruleForm.workName = data.workName;
      this.ruleForm.createDate = data.createDate;
      this.ruleForm.remedyDeadline = data.remedyDeadline;
      this.ruleForm.workReviewTypeName = data.workReviewTypeName;
      this.ruleForm.workTypeName = data.workTypeName;
      this.ruleForm.workDesc = data.workDesc;
    });
  },
  beforeDestroy() {
    Bus.$off("infoBook");
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  text-align: left;
}
/deep/ .el-form-item--small .el-form-item__content {
  text-align: left;
}
</style>
